import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  optionBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '-25px 0 8px'
  },
  optionId: {
    backgroundColor: theme.palette.blue_300.main,
    borderRadius: '100%',
    width: '18px',
    height: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& span': {
      fontSize: '0.8rem'
    }
  },

  addButton: {
        position: 'absolute',
        width: 20,
        height: 20,
        borderRadius: '50%',
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.common.white,
        color: theme.palette.grey[600],
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10,
        '&:hover': {
            backgroundColor: theme.palette.grey[200],
        },
    },
    rightAddButton: {
        top: '50%',
        right: -25,
        transform: 'translateY(-50%)',
    },
    bottomAddButton: {
        left: '50%',
        bottom: -25,
        transform: 'translateX(-50%)',
    },
}))
